import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X, Loader2 } from "lucide-react";

/** Modal to run a test-trigger picking a REAL client from the tenant. */
export function TestRunModal({ automation, onClose, onRan }) {
  const [clients, setClients] = useState([]);
  const [tags, setTags] = useState([]);
  const [clientId, setClientId] = useState("");
  const [addedTag, setAddedTag] = useState("");
  const [running, setRunning] = useState(false);

  useEffect(() => {
    Promise.all([api.get("/clients"), api.get("/tags").catch(() => ({ data: [] }))])
      .then(([c, t]) => { setClients(c.data); setTags(t.data); });
  }, []);

  const run = async () => {
    if (!clientId) { toast.error("Seleziona un cliente"); return; }
    const cli = clients.find((c) => c.id === clientId);
    if (!cli) return;
    setRunning(true);
    try {
      const ctx = {
        client: cli,
        appointment: { id: "test-appt", start: new Date(Date.now() + 3600_000).toISOString(), status: "scheduled", service_id: "test" },
        invoice: { id: "test-inv", total: 150, payment_method: "cash" },
        added_tag: addedTag,
      };
      const r = await api.post("/automations/test-trigger", {
        trigger_type: automation.trigger?.type || "manual",
        context: ctx,
      });
      toast.success(`Trigger inviato · ${r.data.actions_enqueued} azion${r.data.actions_enqueued === 1 ? "e" : "i"} in coda`);
      onRan();
      onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    finally { setRunning(false); }
  };

  return (
    <div className="fixed inset-0 z-40 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="sp-card w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <span className="label-eyebrow">Prova automazione</span>
            <h3 className="font-display text-xl font-black mt-1">{automation.name}</h3>
          </div>
          <button onClick={onClose} data-testid="test-modal-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="space-y-3">
          <div>
            <label className="text-sm font-bold">Cliente di prova</label>
            <select data-testid="test-client-select" className="sp-input mt-1" value={clientId} onChange={(e) => setClientId(e.target.value)}>
              <option value="">— Scegli cliente —</option>
              {clients.map((c) => <option key={c.id} value={c.id}>{c.name}{c.phone ? ` · ${c.phone}` : ""}</option>)}
            </select>
          </div>
          {automation.trigger?.type === "client_tag_added" && (
            <div>
              <label className="text-sm font-bold">Tag da simulare come appena aggiunto</label>
              <select data-testid="test-added-tag" className="sp-input mt-1" value={addedTag} onChange={(e) => setAddedTag(e.target.value)}>
                <option value="">— Nessuno —</option>
                {tags.map((t) => <option key={t.id} value={t.name}>{t.name}</option>)}
              </select>
            </div>
          )}
          <div className="text-[11px] text-[color:var(--sp-text-muted)] bg-[color:var(--sp-subtle)] rounded p-2">
            L&apos;automazione verrà eseguita una volta con dati di test (finto appuntamento, finto incasso di €150).
          </div>
          <div className="flex gap-2">
            <button onClick={onClose} className="sp-btn-ghost flex-1">Annulla</button>
            <button data-testid="test-run-btn" disabled={running} onClick={run} className="sp-btn-primary flex-1 inline-flex items-center justify-center gap-2">
              {running && <Loader2 className="h-4 w-4 animate-spin" />} Esegui
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
